(function(angular) {
    'use strict';

    var directiveModule = angular.module('angularjs-dropdown-multiselect', []);
    var selectedSupplierIds = "";

    directiveModule.directive('dmDropdownStaticInclude', ['$compile','$timeout', function($compile,$timeout) {
        return function(scope, element, attrs) {
            var template = attrs.dmDropdownStaticInclude;
            var contents = element.html(template).contents();
            $compile(contents)(scope);
        };
    }]);

    directiveModule.directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse', '$rootScope','$http',function($filter, $document, $compile, $parse,$rootScope,$http) {
        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                groupBy: '@',
                disabled: "=",
                stakeholder:"=",
                actualOptions:"=",
                specialGroupBy:"=",
                /* new scope variable mappings */
                parentModelOptions:"<",
                parentModelValues : "=",
                groupByModel:'<',
                parentElmClass :"=",
                customAddHandler: "=",
                showAdditionalOption : "=",
                parentOptionIds : "=",
                parentVal : "=",
                updateFn :'&',
                rowData : '=',
                cliGroupBy : '=',
                deleteDocumentTag: "=",
            },
            templateUrl:$rootScope.createHtmlUrl("ui2.0/directiveTemplates/multiSelectDropDownTemplate.html"),
            link: function($scope, $element, $attrs) {
                $scope.intl_msg = $rootScope.intl_msg;
                angular.element(".filterhead").find(".beta-switch").show();
                $scope.elm = $element;
                $scope.groupMapper={};
                $scope.enableAddOptions = false;
                $scope.tempOptions =  angular.copy($scope.options);
                $scope.orderedItems = $scope.options;
                $scope.visibleOptions = {data:[]};
                $scope.isStakeholder = false;
                $scope.ifCUStakeHolder = false;
                let sc = $('ng-view').scope() || angular.element(document.body).scope();
                $scope.entityTypeId = sc && sc.data && sc.data.entityTypeId && sc.data.entityTypeId.values;
                $scope.entityId = sc && sc.data && sc.data.id && sc.data.id.values;
                if($scope.groupBy){
                    $scope.groupMapper = sJq._.keyBy($scope.parentModelOptions,'id');
                }
                if($scope.showAdditionalOption){
                    $scope.additionalOptions = [];
                      $scope.tempOptions.forEach(function(item, index){
                        if(item.additionalOption == true){
                            $scope.additionalOptions.push(item);
                            var itemIndex = $scope.options.findIndex(obj=>obj.name==item.name);
                            $scope.options.splice(itemIndex,1);
                        }
                    });
                      if($scope.options.length == 0 && $scope.additionalOptions.length){
                          $scope.options = angular.copy($scope.additionalOptions);
                          $scope.additionalOptions = [];
                      }
                      $scope.tempOptions = $scope.options;
                    $scope.orderedItems = $scope.options;
                }
                if($attrs.autocompleteurl || $attrs.autocomplete){
                    $element.data('acUrl',$attrs.autocompleteurl);
                    $scope.autoComplete=true;
                }
                if($attrs.hideselected == "true"){
                    $scope.hideselected = true;
                }
                if($element.data('slmetFilter')){
                    $scope.slmetfilter = true;
                }
                $scope.extraSettings.groupByTextProvider =function(groupValue,obj) {
                        if($scope.parentModelOptions && $scope.groupMapper[groupValue]){
                            return $scope.groupMapper[groupValue]['name'];
                        }else if($scope.parentModelValues && $scope.parentModelValues.length){
                            var index = $scope.parentModelValues.findIndex(function(item){ return item.id == groupValue});
                            return $scope.parentModelValues[index]['name'];
                        }
                        if($scope.settings.autoCompleteUrl){
                            return obj.parentName || obj.group;
                        }else{
                            if($scope.groupBy){
                                return obj[($scope.groupBy)];
                            }
                            if($scope.settings.groupBy == "parentId"){
                                return obj.parentName;
                            }

                            if($scope.settings.groupBy == "group"){
                                return obj.group;
                            }
                        }
                        /*if(!obj){
                            return $scope.groupMapper[groupValue]['name'];
                        }else{
                            return obj.parentName;
                        }*/


                }


                $scope.$watch("groupByModel",function(newVal,oldVal){
                    if (angular.isDefined($scope.options)) {
                        $scope.createOrderedItems($scope.options,$scope.selectedModel);
                    }
                },true);
                var $dropdownTrigger = $element.children()[0];
                if ($scope.selectedModel) {
                    if($scope.selectedModel.id == 0){
                        $scope.selectedModel.id ='0';
                    }
                    $scope.selectedModel = $scope.selectedModel;
                } else {
                    if ($attrs.selectionlimit == 1) {
                        $scope.selectedModel = {};
                    } else {
                        $scope.selectedModel = [];
                    }
                }

                if($attrs.filterId === "1") {
                    if($scope.selectedModel.length > 0) {
                        let supplierIds = "";
                        $scope.selectedModel.forEach(option => {
                            supplierIds += (supplierIds ? "," : "") + option.id;
                        });
                        selectedSupplierIds = supplierIds;
                    } else selectedSupplierIds = "";
                }
                $scope.useAutocomplete = (e) => {
                    const checkAutoComplete = e.target.closest(`.autoComplete_dl`);
                    if(!!checkAutoComplete){
                        // make api call and fill options
                        $scope.options = [];
                        let id = checkAutoComplete.getAttribute('id').split('-')[1];
                        id && $scope.autoCompleteApi(id,e);
                    }
                };

                SirionUtils.doesNotHaveChkBoxHandler(null,!$scope.selectedModel.length,$element);
                $scope.toggleDropdown = function(e) {
                    $scope.useAutocomplete(e);
                    $scope.isStakeholder = $scope.settings.currentFilterId ? true : false;
                    if (($scope.extraSettings.isCli || $scope.isStakeholder || $scope.settings.documentTagsEnabled) && $scope.autoComplete) {
                        const RESET_CHANNEL = 'resetDropdownValues';
                        window.sarc.channelInstall(RESET_CHANNEL);
                        var searchQuery = ($scope.input?.searchFilter ?? '').trim();
                        if (searchQuery) {
                            $scope.loadOptions(e, searchQuery, null, false);
                        } else {
                            $scope.loadOptions(e, '', null, true);
                            window.sarc.channelBroadcast(RESET_CHANNEL, '', `${RESET_CHANNEL}Channel`);
                        }
                    }else{
                        if($scope.isStakeholder) {
                            if (_.get($scope.options, 'length') > 0) {
                                if($scope.options[0].id != 0){
                                    $scope.options.unshift({id: 0, name: intl_msg[34708], idType: 2, userGroup: false});
                                }
                            }else{
                                $scope.options.unshift({id: 0, name: intl_msg[34708], idType: 2, userGroup: false});
                            }
                        }
                    }
                    $('.selectDDbox').hide();
                    e.stopPropagation();
                    e.preventDefault();
                    /* to prevent the opening of dropdown in case of click on cross icon of selected options */
                    /*if(e.target && angular.element(e.target).hasClass('dropdown-toggle')){
                        return;
                    }*/
                    /* To hide all other opened muiltiselct dropdowns */
                    var allMSDD = angular.element('.dropdown-multiselect');
                    for(var i =0;i<allMSDD.length;i++){
                        if(angular.element(allMSDD[i]).scope().open && angular.element(allMSDD[i]).scope().$id != $scope.$id){
                            angular.element(allMSDD[i]).scope().open = false;
                            angular.element(allMSDD[i]).scope().close();
                        }

                    }
                    if ($scope.open) {
                        $scope.close();
                    } else {
                        $scope.open = true;
                        $scope.$emit("closeDatePicker");
                    }
                    var searchField = angular.element($element)[0].querySelector('.searchField');
                    if ($scope.settings.keyboardControls) {
                        if ($scope.open) {
                            if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                                setTimeout(function() {
                                    searchField && searchField.focus();
                                }, 0);
                            } else {
                                focusFirstOption();
                            }
                        }
                    }
                    if ($scope.settings.enableSearch) {
                        if ($scope.open) {
                            setTimeout(function () {
                                !$scope.$$phase && !$rootScope.$$phase && $scope.$apply();
                                searchField && searchField.focus();
                            }, 0);
                        }
                    }
                    if ($scope.open) {
                        if(!$scope.settings.autoCompleteUrl) {
                            $scope.createGroupBy();
                        }
                        setTimeout(function () {
                            if( $scope.settings && $scope.settings.parentElmClass){
                                var parentElemClass = $scope.settings.parentElmClass;
                                var _flag = $element.find('.dropdown-toggle').closest('.jx-showPageNew').hasClass("searchable_fields_page");
                                if( _flag ){
                                    parentElemClass = "tab-detail";
                                }
                                angular.element($element)[0].querySelector('.searchField').focus();
                                globalFunc.scrollElemToChild($element.find('.dropdown-toggle'),$element.find('.dropdown-toggle').closest('.'+parentElemClass),$element.find('.dropdown-menu'));
                            }
                        }, 0);
                    }
                };

                $scope.checkboxClick = function($event, id) {
                    $scope.setSelectedItem(id, false, true,$event);
                    $event.stopImmediatePropagation();
                };
                var t;
                $scope.deleteSelectedItemId = function($event,id){
                    $event.stopPropagation();
                    $event.preventDefault();
                    // if((!$scope.options || $scope.options.length == 0) && $scope.settings.autoCompleteUrl){
                    //     $scope.loadOptions($event,$scope.input.searchFilter,id);
                    // }else{
                        $scope.checkboxClick($event,id);
                    // }
                    if($element.data('elemQname')){
                        $scope.externalEvents.onClose($element.data('elemQname'), $element);
                    }
                    if($element.scope() && $element.scope().response && $element.scope().response.calendarFilter){
                        var id =$element.parent()[0].id;
                        var selectedModel = $scope.selectedModel;
                        var idFromModel =[];
                        selectedModel.filter((model)=>{
                            idFromModel.push(model.id);
                        });
                        if(id=='listFilter_relations'){
                            getNewFilterForCalendar(idFromModel,'relations',$element);
                        }
                        if(id=='listFilter_contracts'){
                            getNewFilterForCalendar(idFromModel,'contracts',$element);
                        }

                    }

                    // $scope.checkboxClick($event,id);
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop,
                    onSelectionChanged: angular.noop,
                    onClose: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: parseInt($attrs.selectionlimit) || 0,
                    showCheckAll: true,
                    showUncheckAll: true,
                    showEnableSearchButton: false,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop,
                    styleActive: false,
                    keyboardControls: true,
                    template: '{{getPropertyForObject(option, settings.displayProp)}}',
                    searchField: '$',
                    showAllSelectedText: false,
                    checkBoxes : $attrs.checkboxes == 'true',
                    autoCompleteUrl : $attrs.autocompleteurl,
                    showParentCheckBoxes:true,
                    parentElmClass:undefined,
                    customSelectedModel: undefined,
                    currentFilterId: $attrs.currentfilterid,
                    deleteIconShow:  $attrs.deleteiconshow == "true",
                    documentTagsEnabled: $attrs.documenttagsenabled == 'true',
                    hasDocumentTagEditAccess: $attrs.hasdocumenttageditaccess == 'true',
            };

                $scope.texts = {
                    checkAll:    intl_msg[25740]||'Check All',
                    uncheckAll:  intl_msg[25739]||'Uncheck All',
                    selectionCount: intl_msg[27930]||'checked',
                    selectionOf:  intl_msg[27931]||'/',
                    searchPlaceholder: $scope.settings.currentFilterId == '53' || (['shareViewBox', 'myShareAutocomplete', 'bulkEditStakeholders'].indexOf($attrs.id) != -1) ? 'Search by name or email':intl_msg[27932]||'Search...',
                    buttonDefaultText: intl_msg[23637]||'Select',
                    dynamicButtonTextSuffix: intl_msg[27930]||'checked',
                    disableSearch: intl_msg[27934]||'Disable search',
                    enableSearch:  intl_msg[27941]||'Enable search',
                    selectGroup:   intl_msg[25517]||'Select all:',
                    allSelectedText: intl_msg[24274]||'All'
                };

                $scope.input = {
                    searchFilter: $scope.searchFilter || ''
                };
                if($scope.slmetfilter){
                    transFormOptions($scope.options);
                }

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function(newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.createOrderedItems(newValue);
                            //$scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });

                }else if(!$scope.settings.autoCompleteUrl){
                    $scope.$watch('options', function(newValue) {
                        if (angular.isDefined(newValue)) {
                            //$scope.createOrderedItems(newValue);
                            $scope.orderedItems = newValue;
                        }
                    });
                    $scope.$watch('options.length', function(newValue) {
                        if (angular.isDefined($scope.options)) {
                            $scope.orderedItems = $scope.options;
                        }
                    });
                }

                $scope.$watch('selectedModel', function(newValue) {
                    if (newValue != undefined && !Array.isArray(newValue) || $scope.settings.selectionLimit == '1') {
                        $scope.singleSelection = true;
                    } else {
                        $scope.singleSelection = false;
                    }
                });

                $scope.close = function() {
                    $scope.open = false;
                    //console.log($element.data('elemQname')
                    if($element.data('elemQname')){
                        $scope.externalEvents.onClose($element.data('elemQname'),$element);
                    }
                    if($element.scope() && $element.scope().response && $element.scope().response.calendarFilter){
                        var id =$element.parent()[0].id;
                        var selectedModel = $scope.selectedModel;
                        var idFromModel =[];
                        selectedModel.filter((model)=>{
                            idFromModel.push(model.id);
                        });
                        if(id=='listFilter_relations'){
                            getNewFilterForCalendar(idFromModel,'relations',$element);
                        }
                        if(id=='listFilter_contracts'){
                            getNewFilterForCalendar(idFromModel,'contracts',$element);
                        }

                    }
                }
                var clearRemoveItem = $scope.$on('removeItem',function(event,e,id){
                    $scope.checkboxClick(e,id);
                });
                var clearMSFilterData = $scope.$on('clearMSFilterData',function(e){
                    $scope.selectedModel = [];
                });
                $scope.selectCurrentGroup = function(e,currentGroup) {
                   // $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    if ($scope.orderedItems) {
                        $scope.orderedItems.forEach(function(item) {
                            if (item[$scope.groupBy] === currentGroup || item[$scope.settings.groupBy] === currentGroup) {
                                $scope.setSelectedItem($scope.getPropertyForObject(item, $scope.settings.idProp), angular.element(e.target).prop('checked'), false)
                            }
                        });
                    }
                    $scope.externalEvents.onSelectionChanged();
                };

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);
                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                $attrs.$observe('selectionlimit', function (newValue) {
                    if (angular.isDefined(newValue)) {
                        var newLimit = parseInt(newValue) || 0;
                        $scope.settings.selectionLimit = newLimit;
                        $scope.singleSelection = newLimit === 1;
                        $scope.selectedModel = newLimit === 1 ? {} : [];
                        $scope.settings.checkBoxes = newLimit === 1 ? false : true;
                    }
                });

                $scope.showMoreSelected = false;
                $scope.toggleMoreSelected = function(val){
                    $scope.showMoreSelected = val;
                }

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function(e) {
                        if ($scope.open) {
                            var target = e.target.parentElement;
                            var parentFound = false;

                            while (angular.isDefined(target) && target !== null && !parentFound) {
                                if (!!target.className.split && contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                    if (target === $dropdownTrigger) {
                                        parentFound = true;
                                    }
                                }
                                target = target.parentElement;
                            }

                            if (!parentFound) {
                                try{
                                    !$scope.$$phase && !$rootScope.$$phase && $scope.$apply(function() {$scope.close();})
                                } catch(e){}
                            }
                        }
                    });
                }

                $scope.getGroupLabel = function(groupValue,obj) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue,obj);
                    }

                    return groupValue;
                };

                function textWidth(text) {
                    var $btn = $element.find('button');
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    ctx.font = $btn.css('font-size') + $btn.css('font-family');
                    // http://stackoverflow.com/questions/38823353/chrome-canvas-2d-context-measuretext-giving-me-weird-results
                    ctx.originalFont = $btn.css('font-size') + $btn.css('font-family');
                    ctx.fillStyle = '#000000';
                    return ctx.measureText(text).width;
                }

                $scope.getButtonText = function() {
                    if ($scope.settings.dynamicTitle && $scope.selectedModel && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && Object.keys($scope.selectedModel).length > 0) && !($attrs.fromdelegationcreate === "true"))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {

                            var paddingWidth = 12 * 2,
                                borderWidth = 1 * 2,
                                dropdownIconWidth = 8;
                            var widthLimit = $element[0].offsetWidth - paddingWidth - borderWidth - dropdownIconWidth;

                            var itemsText = [];

                            angular.forEach($scope.options, function(optionItem) {
                                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                    itemsText.push(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                itemsText.push('...');
                            }

                            var result = itemsText.join(', ');
                            var index = result.length - 4;
                            if ($element[0].offsetWidth === 0)
                                return result;
                            while (textWidth(result) > widthLimit && index > 0) {
                                if (itemsText[itemsText.length - 1] !== "...") {
                                    itemsText.push('...');
                                    result = result + "...";
                                }
                                result = result.slice(0, index) + result.slice(index + 1);
                                index--;
                            }

                            return result;
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            }

                            if ($scope.settings.showAllSelectedText && totalSelected === $scope.options.length) {
                                return $scope.texts.allSelectedText;
                            }

                            return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getPropertyForObject = function(object, property) {

                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        if($scope.slmetfilter){
                            return object[property].split(':;')[0];
                        }else{
                            return object[property] === null ? undefined : object[property];
                        }

                    }


                    return undefined;
                };

                $scope.getSearchedItemsLength  = function(){
                    var searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
                    return searchResult && searchResult.length;
                }

                $scope.selectAll = function(event) {
                    var searchResult;
                    $scope.deselectAll(true);
                    $scope.externalEvents.onSelectAll();

                    //searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
                    if($scope.orderedItems?.length){
                        searchResult = $filter('filter')($scope.orderedItems, $scope.getFilter($scope.input.searchFilter));
                    }else{
                        searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
                    }
                    if ($scope.isStakeholder) {
                        let found = false;
                        if ($scope.autoComplete) {
                            found = $scope.options.some(el => el.id === 0);
                        } else {
                            found = searchResult.some(el => el.id === 0);
                        }
                        if (found) {
                            searchResult.unshift({id: 0, name: intl_msg[34708], idType: 2, userGroup: false})
                        }
                    }
                    angular.forEach(searchResult, function(value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true, false);
                    });
                    !$scope.extraSettings.isCli ? $scope.externalEvents.onSelectionChanged() : $scope.externalEvents.onSelectionChanged($scope.selectedModel,$attrs.cliTableRowKey);
                    $scope.selectedGroup = null;
                    if($element.attr('validation2') != undefined){
                        $element.blur();
                    }
                    SirionUtils.doesNotHaveChkBoxHandler(event,false);
                };

                $scope.deselectAll = function(dontSendEvent,event) {
                    dontSendEvent = dontSendEvent || false;

                    if (!dontSendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        if($scope.additionalOptions) {
                            var superSet = {};
                            $scope.options.forEach(function (obj) {
                                superSet[obj.id] = obj.name;
                            });
                            var tempModel = [];
                            $scope.selectedModel.forEach(function (obj) {
                                if (!superSet[obj.id]) {
                                    tempModel.push(obj);
                                }
                            });
                            $scope.selectedModel = tempModel;
                        } else {
                            $scope.selectedModel.splice(0, $scope.selectedModel.length);
                        }
                    }
                    if (!dontSendEvent) {
                        !$scope.extraSettings.isCli ? $scope.externalEvents.onSelectionChanged() : $scope.externalEvents.onSelectionChanged($scope.selectedModel,$attrs.cliTableRowKey);
                    }
                    $scope.selectedGroup = null;
                    if($element.attr('validation2') != undefined){
                        $element.blur();
                    }
                    SirionUtils.doesNotHaveChkBoxHandler(event,true);
                    //emitting  is uncheckAll selected for UI-10009
                    if(!_.isEmpty($attrs.flagMultiselectQs) && JSON.parse($attrs.flagMultiselectQs)){
                        var isUncheckAllSelected={
                            uncheckAllSelected: $scope.singleSelection,
                            selectedFieldSet: JSON.parse($attrs.selectedFieldSet)
                        }
                        $rootScope.$emit("isUncheckAllSelected",isUncheckAllSelected);
                    }
                };
                $scope.oldLength = -1;
                $scope.widthLimit = 0;
                $scope.setSelectedItem = function(id, dontRemove, fireSelectionChange,event) {
                    let prevSelectedObj = {}
                    const colInfo = $attrs.colinfo && JSON.parse($attrs.colinfo);
                    event && event.stopPropagation();
                    var findObj = getFindObj(id);
                    var finalObj = null;
                    if ($scope.settings.externalIdProp === '') {
                        finalObj = find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }
                    if ($scope.singleSelection) {
                        if(id == $scope.selectedModel.id)
                            finalObj = false;
                        angular.extend(prevSelectedObj, $scope.selectedModel);
                        if (!finalObj) clearObject($scope.selectedModel);
                        if($attrs.fromdelegationcreate === 'true' || $scope.extraSettings.isCli){
                            angular.extend($scope.selectedModel, finalObj);
                        } else {
                            $scope.selectedModel = JSON.parse(JSON.stringify(finalObj));
                        }
                        if (fireSelectionChange) {
                            $scope.externalEvents.onItemSelect(finalObj,$attrs.cliTableRowKey, false, colInfo);
                        }
                        if ($scope.settings.closeOnSelect || $scope.settings.closeOnDeselect) $scope.close();
                        $scope.externalEvents.onItemDeselect($scope.selectedModel,$attrs.cliTableRowKey, true);
                    } else {
                        dontRemove = dontRemove || false;

                        var exists = findIndex($scope.selectedModel, findObj) !== -1;
                        //emitting questionnaire data for UI-10009
                        if(!_.isEmpty($attrs.flagMultiselectQs) && JSON.parse($attrs.flagMultiselectQs)){
                            var data={
                                selectedModelArray: finalObj,
                                selectedFieldSet: JSON.parse($attrs.selectedFieldSet),
                                isSelectedModelRemoved: exists
                            }
                            $rootScope.$emit("questionnaireData",data);
                        }

                        if (!dontRemove && exists) {
                            $scope.selectedModel.splice(findIndex($scope.selectedModel, findObj), 1);
                            if(!$scope.extraSettings.isCli){
                                $scope.externalEvents.onItemDeselect(findObj);
                            } else {
                                $scope.externalEvents.onItemDeselect($scope.selectedModel,$attrs.cliTableRowKey);
                            }

                            if ($scope.settings.closeOnDeselect) $scope.close();
                        } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                            if(finalObj) {
                                finalObj?.id && (finalObj.value = finalObj.id);
                                $scope.selectedModel.push(finalObj);
                            }
                            if (fireSelectionChange) {
                                if(!$scope.extraSettings.isCli){
                                    $scope.externalEvents.onItemSelect(finalObj);
                                } else {
                                        $scope.externalEvents.onItemSelect($scope.selectedModel,$attrs.cliTableRowKey, false, colInfo)
                                }
                            }
                            if ($scope.settings.closeOnSelect) $scope.close();
                            if ($scope.settings.selectionLimit > 0 && $scope.selectedModel.length === $scope.settings.selectionLimit) {
                                $scope.externalEvents.onMaxSelectionReached();
                            }
                        }

                        SirionUtils.doesNotHaveChkBoxHandler(event,!$scope.selectedModel.length)

                    }
                    if($element.attr("name")=="countries" || $element.attr("name")=="globalCountries") {
                        var valuesSelected = [];
                        var parentIds = [];
                        $scope.selectedModel.forEach(function (pt) {
                            parentIds.push(pt.id)
                        });
                        var fieldEle = $element.closest("fieldset").find("[fieldname='states']");
                        if(fieldEle.length){
                            var fieldData = fieldEle.data("fieldData");
                            fieldData.selectedVals.forEach(function (d) {
                                if (parentIds.indexOf(d.parentId) > -1) {
                                    valuesSelected.push(d);
                                }
                            });
                            fieldData.selectedVals = valuesSelected;
                            var selectedElmDiv = fieldEle.closest(".label-height").find('.jx-selected');
                            selectedElmDiv.html('');
                            fieldData.selectedVals.forEach(function(d,i){
                                var selectedElement = angular.element('<span/>',{'class':'showSelected abc badge1 jx-msBadge','index':i,'text':d.name});
                                selectedElement.append(angular.element('<i/>',{'class':"icon-close",'onclick':'event.preventDefault(); event.stopPropagation();$(this).closest(".label-height").find(".ui-autocomplete-input").scope().removeMe($(this),'+d.id+')'}));
                                selectedElmDiv.append(selectedElement);
                            });
                        }
                    }

                    if (fireSelectionChange) {
                        $scope.externalEvents.onSelectionChanged($attrs.delegateuserfrom === 'true' ? {finalObj, prevSelectedObj} : null);
                    }
                    $scope.selectedGroup = null;
                    if($element.attr('validation2') != undefined){
                        $element.blur();
                    }
                };

                $scope.isChecked = function(id) {
                    if(!$scope.selectedModel)
                        $scope.selectedModel = [];
                    if ($scope.singleSelection) {
                        if ($scope.settings.externalIdProp === '') {
                            return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] == getFindObj(id)[$scope.settings.idProp];
                        }
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.externalIdProp]) && $scope.selectedModel[$scope.settings.externalIdProp] === getFindObj(id)[$scope.settings.externalIdProp];
                    }

                    return findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.isCheckedParentGroup = function(parenId){
                    if($scope.settings.groupBy){
                        if(_.filter($scope.selectedModel,function(o){return o[$scope.settings.groupBy] == parenId}).length == _.filter($scope.orderedItems,function(o){return o[$scope.settings.groupBy] == parenId}).length)
                        {
                            return true;
                        }
                        return false;
                    }
                }

                $scope.externalEvents.onInitDone();

                $scope.keyDownLink = function(event) {
                    var sourceScope = angular.element(event.target).scope();
                    var nextOption;
                    var parent = event.target.parentNode;
                    if (!$scope.settings.keyboardControls) {
                        return;
                    }
                    if (event.keyCode === 13 || event.keyCode === 32) { // enter
                        event.preventDefault();
                        if (!!sourceScope.option) {
                            $scope.setSelectedItem($scope.getPropertyForObject(sourceScope.option, $scope.settings.idProp), false, true);
                        } else if (event.target.id === 'deselectAll') {
                            $scope.deselectAll();
                        } else if (event.target.id === 'selectAll') {
                            $scope.selectAll();
                        }
                    } else if (event.keyCode === 38) { // up arrow
                        event.preventDefault();
                        if (!!parent.previousElementSibling) {
                            nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
                        }
                        while (!nextOption && !!parent) {
                            parent = parent.previousElementSibling;
                            if (!!parent) {
                                nextOption = parent.querySelector('a') || parent.querySelector('input');
                            }
                        }
                        if (!!nextOption) {
                            nextOption.focus();
                        }
                    } else if (event.keyCode === 40) { // down arrow
                        event.preventDefault();
                        if (!!parent.nextElementSibling) {
                            nextOption = parent.nextElementSibling.querySelector('a') || parent.nextElementSibling.querySelector('input');
                        }
                        while (!nextOption && !!parent) {
                            parent = parent.nextElementSibling;
                            if (!!parent) {
                                nextOption = parent.querySelector('a') || parent.querySelector('input');
                            }
                        }
                        if (!!nextOption) {
                            nextOption.focus();
                        }
                    } else if (event.keyCode === 27) {
                        event.preventDefault();

                        $scope.toggleDropdown(event);
                    }
                };

                $scope.autoCompleteApi = _.debounce((id,event)=>{
                    let url = `/options/${id}?pageType=1&entityTpeId=1&parentEntityId=&pageEntityTypeId=1&fieldId=&offset=0&listId=217&expandAutoComplete=true`;
                    setTimeout(() => {
                        const query = event?.target.value;
                        !!query && (url+=`&query=${query.trim()}`);
                        $http.get(url && window.addtStamp(url,true)).then(function (response) {
                            $scope.options = response.data.data;
                        }).catch(error => window.systemWarning(error));
                    },0);
                },300);

                $scope.keyDownSearchDefault = function(event) {
                    var parent = event.target.parentNode.parentNode;
                    var nextOption;
                    if (!$scope.settings.keyboardControls) {
                        return;
                    }
                    if (event.keyCode === 9 || event.keyCode === 40) { //tab
                        event.preventDefault();
                        focusFirstOption();
                    } else if (event.keyCode === 38) {
                        event.preventDefault();
                        if (!!parent.previousElementSibling) {
                            nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
                        }
                        while (!nextOption && !!parent) {
                            parent = parent.previousElementSibling;
                            if (!!parent) {
                                nextOption = parent.querySelector('a') || parent.querySelector('input');
                            }
                        }
                        if (!!nextOption) {
                            nextOption.focus();
                        }
                    } else if (event.keyCode === 27) {
                        event.preventDefault();

                        $scope.toggleDropdown(event);
                    }
                    // check if field requires autocomplete
                    $scope.useAutocomplete(event);
                };

                $scope.keyDownSearch = function(event, searchFilter) {
                    var searchResult;
                    if (!$scope.settings.keyboardControls) {
                        return;
                    }
                    if (event.keyCode === 13) {
                        if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                            searchResult = $filter('filter')($scope.options, $scope.getFilter(searchFilter));
                            if (searchResult.length === 1) {
                                $scope.setSelectedItem($scope.getPropertyForObject(searchResult[0], $scope.settings.idProp), false, true);
                            }
                        } else if ($scope.settings.enableSearch) {
                            $scope.selectAll();
                        }
                    }
                };

                $scope.getFilter = function(searchFilter) {
                    var filter = {};
                    filter[$scope.settings.searchField] = searchFilter;
                    return filter;
                };

                $scope.toggleSearch = function($event) {
                    if ($event) {
                        $event.stopPropagation();
                    }
                    $scope.settings.enableSearch = !$scope.settings.enableSearch;
                    if (!$scope.settings.enableSearch) {
                        $scope.input.searchFilter = '';
                    }
                };

                $scope.keyDownToggleSearch = function() {
                    if (!$scope.settings.keyboardControls) {
                        return;
                    }
                    if (event.keyCode === 13) {
                        $scope.toggleSearch();
                        if ($scope.settings.enableSearch) {
                            let searchField = angular.element($element)[0].querySelector('.searchField')
                            setTimeout(
                                function() {
                                    searchField && searchField.focus();
                                }, 0
                            );
                        } else {
                            focusFirstOption();
                        }
                    }
                };

                /* new functions added */
                $scope.createOrderedItems=function(newValue,selectedModel){
                    $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                    var parentIds;
                    if($scope.groupByModel){
                        if($scope.parentModelValues && Array.isArray($scope.parentModelValues)){
                            parentIds = $scope.parentModelValues;
                        }else if($scope.parentModelValues && !Array.isArray($scope.parentModelValues)){
                            parentIds =[$scope.parentModelValues];
                        }else{
                            parentIds = [];
                        }
                        $scope.orderedItems = _.filter($scope.orderedItems,function(o){return _.findIndex(parentIds,function(t){return t.id == o.parentId})>-1});
                        $scope.selectedModel = _.filter($scope.selectedModel,function(o){return _.findIndex(parentIds,function(t){return t.id == o.parentId})>-1});

                    }
                };

                let cliAutoComplete;
                $scope.loadOptions = function(e,query,itemId, isFocused){
                    $scope.isStakeholder = $scope.settings.currentFilterId ? true : false;
                    if ($scope.extraSettings.isCli) {
                        let rowData = $attrs.rowdata && JSON.parse($attrs.rowdata);
                        let defaultCliOptions = $attrs.defaultclioptions && JSON.parse($attrs.defaultclioptions);
                        let initialParentId = null;
                        let updatedParentId = null;
                        let parentIdsArray = [];
                        for (const options in rowData) {
                            if (parseInt($attrs.cligroupby) == rowData[options].drpDwnFieldId) {
                                initialParentId = rowData[options].parentOptionIds;
                            }
                        }
                        for (const options in rowData) {
                            if(typeof rowData[options] == 'function') continue;
                                if (initialParentId == rowData[options].drpDwnFieldId) {
                                    updatedParentId = rowData[options].columnValue;
                            }
                        }
                        if (updatedParentId && typeof updatedParentId === 'object' ) {
                            if (Array.isArray(updatedParentId)) {
                                updatedParentId.map(item => {
                                    parentIdsArray.push(item.id);
                                })
                            } else {
                                parentIdsArray.push(updatedParentId.id);
                            }
                        } else {
                            parentIdsArray = [];
                        }
                        if (isFocused && _.get(defaultCliOptions, 'length') > 0) {
                            if(defaultCliOptions && defaultCliOptions[0].name == 'Base'){
                                defaultCliOptions[0]['id'] = '0';
                            }
                            if (_.isEmpty($scope.options) && defaultCliOptions) {
                                $scope.options = defaultCliOptions;
                                $scope.orderedItems = defaultCliOptions;
                            }else{
                                $scope.orderedItems = $scope.options;
                            }
                        } else if(parentIdsArray && (parentIdsArray[0] != undefined) || !isFocused){
                            $scope.options = [];
                            $scope.orderedItems = [];
                            let endpoint = $attrs.autocompleteurl;
                            let dataToPost = {
                                query,
                                "entityTypeId": parseInt($attrs.entitytypeid),
                                "parentOptionIds": parentIdsArray,
                                "parentEntityTypeId": $scope.entityTypeId,
                                "parentEntityId": $scope.entityId,
                                "templateId": $attrs.templateid && parseInt($attrs.templateid)
                            }
                            clearTimeout(cliAutoComplete);
                            cliAutoComplete = setTimeout(() => {
                                $http.post(endpoint, dataToPost).then(function (resp) {
                                    $scope.options = resp.data.options;
                                    $scope.orderedItems = resp.data.options;
                                    stopLoader();
                                }, function (err) {
                                    stopLoader();
                                    console.log(err);
                                })
                            }, 500)
                        }
                    }else if($attrs.fromdelegationcreate === "true" && $attrs.rolegroup == "true"){
                        const entityTypeIds = JSON.parse($attrs.entitytypeids);
                        const userId = JSON.parse($attrs.userid)?.id;
                        const dataToPost = {
                            "entityTypeIds": entityTypeIds,
                            "userIds": [userId],
                        }
                        let endPoint = window.addtStamp($attrs.autocompleteurl+"&query=" + encodeURIComponent(query))
                        $http.post(endPoint,dataToPost).then(function (response) {
                            if(response?.data?.data){
                                $scope.options = response.data.data;
                                $scope.orderedItems =[];
                                $scope.settings.showCheckAll = false;
                            }

                        }).catch(error => window.systemWarning(error));
                    }
                    else {
                        if (e) {
                            e.stopPropagation();
                        }
                        if ($scope.isStakeholder && (isFocused || !query))  {
                            $scope.options = [{id: 0, name: intl_msg[34708], idType: 2, userGroup: false}];
                            $scope.settings.showCheckAll = false;
                            return;
                        } else {
                            if (query.length <= 0 && !$scope.settings.documentTagsEnabled) {
                                $scope.options = [];
                                $scope.orderedItems = [];
                                return;
                            }
                        }
                        if ($scope.$parent && typeof $scope.$parent.response != "undefined" && $scope.$parent.response && $scope.$parent.response.calendarFilter) {
                            var parentId = $element.parent()[0].id;
                            var supplierSelected = $scope.$parent.filterOptions?.relations?.data?.multiselectValues?.SELECTEDDATA;
                            if (parentId == 'listFilter_contracts' && supplierSelected?.length) {
                                $scope.selectedSupplierIds = []
                                supplierSelected.filter((value) => {
                                    $scope.selectedSupplierIds.push(value.id);
                                });
                            }
                        }
                        if (!isFocused || $scope.settings.documentTagsEnabled) {
                            const index = $scope.settings.autoCompleteUrl.indexOf("supplierIds");
                            if (typeof $scope.selectedSupplierIds != "undefined" && $scope.selectedSupplierIds.length) {
                                var url = $scope.settings.autoCompleteUrl + "&supplierIds=" + $scope.selectedSupplierIds + "&query=" + encodeURIComponent(query);
                                $scope.selectedSupplierIds = [];
                            } else if (selectedSupplierIds !== "" && index === -1 && $attrs.filterId === "2") {
                                var url = $scope.settings.autoCompleteUrl + "&supplierIds=" + selectedSupplierIds + "&query=" + encodeURIComponent(query);
                            } else {
                                var url = $scope.settings.autoCompleteUrl + "&query=" + encodeURIComponent(query);
                            }
							// if (url.indexOf("pageEntityTypeId=") === -1 && $scope.entityTypeId) {
							// 	url += "&pageEntityTypeId=" + $scope.entityTypeId;
							// }
                            if(window.location.href.includes("templateWizard/cdr") && url.indexOf("pageEntityTypeId=") === -1) {
                                url += "&pageEntityTypeId=" + 160;
                            }
                            $http.get(url && window.addtStamp(url,true)).then(function (response) {
                                $scope.options = response.data.data;
                                $scope.orderedItems = [];
                                $scope.settings.showCheckAll = true;
                                if ($scope.isStakeholder) {
                                    if (_.get(response.data, 'data').length) {
                                        $scope.options.unshift({id: 0, name: intl_msg[34708], idType: 2, userGroup: false});
                                    } else {
                                        $scope.options = [];
                                    }
                                }
                                if(!$scope.autoComplete) {
                                    $scope.createGroupBy();
                                }
                                if (itemId) {
                                    $scope.checkboxClick(e, itemId);
                                }
                                if ($scope.settings.parentElmClass) {
                                    setTimeout(function () {
                                        globalFunc.scrollElemToChild($element.find('.dropdown-toggle'), angular.element('.' + $scope.settings.parentElmClass), $element.find('.dropdown-menu'));
                                    }, 10);
                                }
                            }).catch(error => window.systemWarning(error));
                        }
                    }

                };
                $scope.createGroupBy = function () {
                    if($scope.specialGroupBy) {
                        const parentModelValuesList = [].concat($scope.parentModelValues || []);
                        if(parentModelValuesList && parentModelValuesList.length) {
                            const parentIds = parentModelValuesList.reduce((acc,val) => {
                                acc.push(val.id);
                                return acc;
                            },[])
                            $scope.options = $scope.actualOptions.filter(option => parentIds.indexOf(option.parentId) > -1);
                        }else $scope.options =[];
                    }
                    if(_.get($scope.options,'length') && ($scope.options[0].hasOwnProperty('parentId') && $scope.options[0].hasOwnProperty('group'))){
                        $scope.settings.groupBy = 'parentId';
                    }else if(_.get($scope.options,'length') && $scope.options[0].hasOwnProperty('group')){
                        $scope.settings.groupBy = 'group';
                    }
                    var options  = $scope.options
                    if(!$scope.autoCompleteUrl && !$scope.autoComplete ){
                        options = $scope.orderedItems;
                    }
                    $scope.orderedItems = $filter('orderBy')(options, $scope.settings.groupBy);
                }
                
                $scope.changeOptions = function (event) {
                    $scope.enableAddOptions = !$scope.enableAddOptions;
                    if( $scope.enableAddOptions && $scope.additionalOptions && $scope.additionalOptions.length){
                        $scope.options = $scope.additionalOptions;
                    }else{
                        $scope.options = $scope.tempOptions;
                    }
                    $scope.orderedItems =  $scope.options;
                }
                var clearUpdateAutoComUrl = $scope.$on('updateAutoComUrl',function(e,qId,valToSend,id){
                    if(id && $attrs.filterId && (id != $attrs.filterId)){
                        return;
                    }
                    if($element.data("acUrl") != undefined){
                        if (valToSend) {
                            $scope.settings.autoCompleteUrl = $element.data("acUrl")+ "&"+qId +"="+valToSend;
                            $scope.input.searchFilter = '';
                            $scope.orderedItems = [];
                            $scope.selectedModel = [];
                        }else{
                            $scope.settings.autoCompleteUrl = $element.data("acUrl");
                            $scope.orderedItems = [];
                            $scope.options = [];
                        }

                    }
                });

                var clearSearchVal = $scope.$on('clearSearchVal',function(e,obj){
                    $scope.input.searchFilter = '';
                    if($scope.autoComplete) {
                        $scope.options=[];
                        $scope.orderedItems=[];
                    }
                });

                var clearCloseDD = $scope.$on('closeMsDD',function(e){
                    setTimeout(function(){
                        const $pickers = $('.datetime-picker-dropdown');
                        if ($pickers.length > 1) {
                            $pickers.slice(0, -1).remove();
                        }
                    })
                    if($scope.open){
                        $scope.close();
                    }
                });

                function focusFirstOption() {
                    setTimeout(function() {
                        var elementToFocus = angular.element($element)[0].querySelector('.option');
                        if (angular.isDefined(elementToFocus) && elementToFocus != null) {
                            elementToFocus.focus();
                        }
                    }, 0);
                }
                $scope.elm.off("keyup");
                $scope.elm.on("keyup",function(e){
                    if(e.keyCode == 9 && !$scope.open){
                        if (typeof(Event) === 'function') {
                            var ev = new Event("click");
                        } else {
                            var ev = document.createEvent('Event');
                            ev.initEvent("click", true, true);
                        }
                        $scope.toggleDropdown(ev);
                    }
                })

                $scope.$on('$destroy',function(){
                    clearMSFilterData();
                    clearRemoveItem();
                    clearUpdateAutoComUrl();
                    clearSearchVal();
                    clearCloseDD();
                });
            }
        };
    }]);
    function transFormOptions(optObj){
        _.forEach(optObj,function(o){o['bgcolor'] = o.name.split(":;")[2]});
    }
    function contains(collection, target) {
        var containsTarget = false;
        collection.some(function(object) {
            if (object === target) {
                containsTarget = true;
                return true;
            }
        });
        return containsTarget;
    }

    function find(collection, properties) {
        var target;
        if(!collection){
            return false;
        }
        collection.some(function(object) {
            var hasAllSameProperties = true;
            if(object != undefined){
                Object.keys(properties).forEach(function(key) {
                    if (object[key] != properties[key]) {
                        hasAllSameProperties = false;
                    }
                });
            }

            if (hasAllSameProperties) {
                target = object;
                return true
            }
        });

        return target;
    }

    function findIndex(collection, properties) {
        var index = -1;
        var counter = -1;

        collection.some(function(object) {
            var hasAllSameProperties = true;
            counter += 1;
            if(object != undefined){
                Object.keys(properties).forEach(function(key) {
                    if (object[key] != properties[key]) {
                        hasAllSameProperties = false;
                    }
                });
            }

            if (hasAllSameProperties) {
                index = counter;
                return true
            }
        });

        return index;
    }
    directiveModule.filter('getWidthLimit',function(){
        return function(itemList,sc,selector,label)
        {
            if(isIEBrowser){
                sc.widthLimit = (itemList.length < 5) ? itemList.length : 5;
                return (itemList.length < 5) ? itemList.slice(0, itemList.length) : itemList.slice(0,5);
            }
            var list = angular.copy(itemList),
                parent = selector? angular.element(selector): angular.element(sc.elm).find(".jx-selected"),limit = 0,
                width = 0,
                moreElemWidth = commonUtil.getWidthFromText((list.length)+" "+intl_msg[27450], {'font-size':'16px','padding':'10px 0 0 10px'}),
                elementWidth = parent.width();
            angular.forEach(list,function(item,i) {
                if(label)
                    width += (item.label.length*7) + 33;
                else
                    width += (item.name.length*7) + 33;
                if(width < elementWidth - moreElemWidth) {
                    limit = i+1;
                }
            });
            sc.widthLimit = limit;
            return itemList.slice(0,limit);
        }
    });
})(angular);
